import { TLabel } from 'src/types/locales'
import { TISODuration } from 'src/utils/duration-iso.util'
import { EHumanReviewRequestSubject } from 'src/pages/dashboard/_components/human-review-requests.type'

export type TMessageMedEvents = {
  id: number
  name: string
}

export const MINUTE_MULTIPLICATOR = 60 as const
export const HOUR_MULTIPLICATOR = 3600 as const
export const DAY_MULTIPLICATOR = 86400 as const
export type TDelayMultiplicator =
  | typeof MINUTE_MULTIPLICATOR
  | typeof HOUR_MULTIPLICATOR
  | typeof DAY_MULTIPLICATOR

export const MULTIPLICATOR_TO_ISO_UNIT: Record<TDelayMultiplicator, string> = {
  [MINUTE_MULTIPLICATOR]: 'M',
  [HOUR_MULTIPLICATOR]: 'H',
  [DAY_MULTIPLICATOR]: 'D',
}

export type TMessageSchedule = {
  durationDiff: string
  atTime?: string
  avoidedWeekdays?: number[]
  avoidPublicHolidays?: boolean
  avoidedDates?: string[]
  gracePeriodDuration?: string | null
  preventRescheduleOnceTriggered?: boolean
}

export const EProgrammedMessageType = {
  MESSAGE: 'MESSAGE',
  COMPLEX_MESSAGE: 'COMPLEX_MESSAGE',
} as const

// eslint-disable-next-line no-redeclare
export type EProgrammedMessageType = (typeof EProgrammedMessageType)[keyof typeof EProgrammedMessageType]

export const EProgrammedMessageCategories = {
  OTHER: 'OTHER',
  PRE_OPERATIVE_INSTRUCTIONS: 'PRE_OPERATIVE_INSTRUCTIONS',
  CONVOCATION: 'CONVOCATION',
  POST_OPERATIVE_INSTRUCTIONS: 'POST_OPERATIVE_INSTRUCTIONS',
  SATISFACTION: 'SATISFACTION',
  WELCOME_MESSAGE: 'WELCOME_MESSAGE',
  PRE_ADMISSION: 'PRE_ADMISSION',
} as const

// eslint-disable-next-line no-redeclare
export type EProgrammedMessageCategories =
  (typeof EProgrammedMessageCategories)[keyof typeof EProgrammedMessageCategories]

export enum ENotEditableReason {
  GLOBAL_WORKFLOW = 'GLOBAL_WORKFLOW',
  HAS_EVENT_TRIGGER = 'HAS_EVENT_TRIGGER',
  NO_FOLLOWUP = 'NO_FOLLOWUP',
  TRIGGERS_ACROSS_FOLLOWUPS = 'TRIGGERS_ACROSS_FOLLOWUPS',
  UNSUPPORTED_GRAPH = 'UNSUPPORTED_GRAPH',
}

export enum EAgeGroup {
  MINOR = 'MINOR',
  MAJOR = 'MAJOR',
}

export type THumanReviewCheckMessage = {
  subject: EHumanReviewRequestSubject | null
  unreceivedSmsDelay?: TISODuration | null
}

export type TMessageContentRule = {
  message: TLabel
  medicalStaffMemberId: string | null
  ageGroup: EAgeGroup | null
}

export type TProgrammedMessage = {
  id: number
  followupId: number | null
  medEventIds: number[]
  schedule: TMessageSchedule
  messageName: string
  profileRules: TMessageContentRule[]
  type: EProgrammedMessageType
  categories: EProgrammedMessageCategories[] | null
  isEditable: boolean
  notEditableReason: ENotEditableReason | null
  humanReviewCheck?: THumanReviewCheckMessage | null
}

export type TProgrammedMessageFormValues = {
  followupId: number
  medEventIds: number[]
  schedule: TMessageSchedule
  messageName: string
  profileRules: TMessageContentRule[]
  categories: EProgrammedMessageCategories[]
  humanReviewCheck?: THumanReviewCheckMessage | null
}

export type TProgrammedMessageForAPI = TProgrammedMessageFormValues
